/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemRoomArTrackableDefinitionFromJSON, StreemRoomArTrackableDefinitionToJSON, } from './';
export function WallItemArScanningRequestFromJSON(json) {
    return WallItemArScanningRequestFromJSONTyped(json, false);
}
export function WallItemArScanningRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'forUserId': !exists(json, 'for_user_id') ? undefined : json['for_user_id'],
        'forDeviceId': !exists(json, 'for_device_id') ? undefined : json['for_device_id'],
        'trackableDefinition': !exists(json, 'trackable_definition') ? undefined : StreemRoomArTrackableDefinitionFromJSON(json['trackable_definition']),
    };
}
export function WallItemArScanningRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'for_user_id': value.forUserId,
        'for_device_id': value.forDeviceId,
        'trackable_definition': StreemRoomArTrackableDefinitionToJSON(value.trackableDefinition),
    };
}
//# sourceMappingURL=WallItemArScanningRequest.js.map